import React from 'react';
import { useAtomValue } from 'jotai';
import { Avatar as AvatarFit } from '@fiverr-private/fit';
import { Image } from '@fiverr-private/media';
import {
    FederatedSeller,
    useSellerData,
    ProAvatar,
    getWorldCupWinnerBadgeImageUrl,
} from '@fiverr-private/seller_pages_toolbox';
import { rolloutsAtom } from '../../../atoms';
import { ROLLOUTS } from '../../../../server/middlewares/addRolloutsData/constants';
import { VideoAvatar } from '../VideoAvatar/VideoAvatar';
import { avatarWrapperClass, cornerBadgeClass } from './styles.ve.css';

const renderAvatar = ({ introVideoUrl, isPro, username, profileImageUrl }) => {
    if (introVideoUrl) {
        return <VideoAvatar />;
    }
    if (isPro) {
        return <ProAvatar avatarSize="2xl" />;
    }
    return <AvatarFit size={120} username={username} src={profileImageUrl} />;
};

export const Avatar = () => {
    const { profileImageUrl, username, isPro, introVideo, countryCode } = useSellerData(selectSellerSlice);
    const rollouts = useAtomValue(rolloutsAtom);
    const introVideoUrl = introVideo?.url;
    const worldCupWinnerBadgeImageUrl = getWorldCupWinnerBadgeImageUrl({
        countryCode,
        isArgentinaWorldCupWinnerRolloutActive: rollouts[ROLLOUTS.QUALAS_SELLER_PAGE_WORLD_CUP_WINNER_ARGENTINA],
        isSpainWorldCupWinnerRolloutActive: rollouts[ROLLOUTS.QUALAS_SELLER_PAGE_WORLD_CUP_WINNER_SPAIN],
    });

    return (
        <div className={avatarWrapperClass}>
            {renderAvatar({ introVideoUrl, isPro, username, profileImageUrl })}
            {worldCupWinnerBadgeImageUrl && (
                <Image className={cornerBadgeClass} src={worldCupWinnerBadgeImageUrl} alt="" />
            )}
        </div>
    );
};

function selectSellerSlice(seller: FederatedSeller) {
    return {
        username: seller.user.name,
        profileImageUrl: seller.user.profileImageUrl,
        introVideo: seller.introVideo,
        isPro: seller.isPro,
        countryCode: seller.user.address?.countryCode,
    };
}
